const Constants = {

  applicationName: 'RansomStop',

  customerName: 'premier',
  apiHost: 'premier-api',
  domainName: 'ransomstop.com',
  version: '2.3.1',
  userPoolId: 'us-east-1_wUd21N4x8',
  userPoolClientId: '5ds1dgcvh1ndkbsamhnh874ejc',
  authDomain: 'premier-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',
  showBilling: false,

}
export default Constants